import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import {useSuiContext} from '@s-ui/react-context'
import PrimitiveVisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

import {BASE_ELEMENTS_TYPES, LEGEND_WRAPPER_CLASS_NAME} from '../../config.js'
import {INFO_ICON_ROLE} from './config.js'

const FilterWrapperBasicLegendWrapper = ({description, icon: Icon, id, legend, showLegend}) => {
  const {i18n} = useSuiContext()

  const TOOLTIP_ID = `filter-wrapper-basic-legend-tooltip-${id}`

  return showLegend ? (
    <BASE_ELEMENTS_TYPES.LEGEND className={LEGEND_WRAPPER_CLASS_NAME}>
      {legend}
      {Boolean(Icon) && Icon}
      {description && (
        <AtomTooltip content={<div id={TOOLTIP_ID}>{description}</div>} placement={AtomTooltipPlacements.AUTO}>
          <div
            aria-describedby={TOOLTIP_ID}
            aria-label={i18n.t('FILTERS.TOOLTIP.LABEL')}
            role={BASE_ELEMENTS_TYPES.BUTTON}
          >
            <IconInfoOutline aria-hidden role={INFO_ICON_ROLE} size={atomIconSizes.medium} />
          </div>
        </AtomTooltip>
      )}
    </BASE_ELEMENTS_TYPES.LEGEND>
  ) : (
    <PrimitiveVisuallyHidden as={BASE_ELEMENTS_TYPES.LEGEND}>{legend}</PrimitiveVisuallyHidden>
  )
}

FilterWrapperBasicLegendWrapper.displayName = 'FilterWrapperBasicLegendWrapper'
FilterWrapperBasicLegendWrapper.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.node,
  id: PropTypes.string,
  legend: PropTypes.string,
  showLegend: PropTypes.node
}

export default FilterWrapperBasicLegendWrapper
